import type { GetServerSideProps } from 'next';
import React from 'react';
import Archive from 'components/archive';
import AuthorInfo from 'components/author-info';
import PageWrap from 'components/page-wrap';
import Blocks from 'components/blocks';
import RoundedSection from 'components/rounded-section';
import { getAuthorPage, AuthorPageProps } from 'lib/queries/blog';
import { useWordPressContext } from 'contexts/wordpress-provider';

export const getServerSideProps: GetServerSideProps = async context => {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59',
  );

  return await getAuthorPage(context);
};

export default function AuthorPage({
  page: {
    id,
    name,
    modified,
    description,
    uri,
    seo,
    acf: { blocks, image, list, quote, socialNetworks },
  },
  postsList,
}: AuthorPageProps) {
  const { translations, authorsPageRoundedSection } = useWordPressContext();
  const numPosts = postsList?.pagination?.total;

  return (
    <PageWrap seo={seo} title={name} pageType="author">
      <AuthorInfo
        id={id}
        name={name}
        description={description}
        uri={uri}
        image={image}
        jobTitles={list.map(({ jobTitle }) => jobTitle)}
        quote={quote}
        socialNetworks={socialNetworks}
        isPageTitle={true}
        variant="xlarge"
      />
      <Blocks blocks={blocks} pageType="author" modified={modified} />
      <Archive
        posts={postsList.posts}
        pagination={postsList.pagination}
        variant="smallFeatured"
        title={translations['Articles']}
        subtitle={translations[`{articles} Articles written by {name}`]
          .replace('{articles}', numPosts.toString())
          .replace('{name}', name)}
        className="leafwell-author-profile"
      />
      <RoundedSection {...authorsPageRoundedSection} />
    </PageWrap>
  );
}
